import panUtil from "../../../utils/common";
import { MD5 } from "@/components/md5";
import fileService from "@/api/file";
import getters from "../../getters";
import store from "../../index";
import http from "@/utils/http";
import OSS from "ali-oss";

const task = {
  namespaced: true,
  state: {
    taskList: new Array(),
    viewFlag: false,
  },
  mutations: {
    clear(state) {
      state.taskList = new Array();
      state.viewFlag = false;
    },
    add(state, taskItem) {
      let index = state.taskList.findIndex(
        (it) => it.fileName === taskItem.fileName
      );
      if (index == -1) {
        state.taskList.push(taskItem);
      }
    },
    remove(state, fileName) {
      for (let i = 0; i < state.taskList.length; i++) {
        if (fileName === state.taskList[i].fileName) {
          state.taskList.splice(i, 1);
          break;
        }
      }
    },
    updateStatus(state, param) {
      let taskItem = state.taskList.find(
        (taskItem) => param.fileName === taskItem.fileName
      );
      taskItem.status = param.status;
      if (param.client) {
        taskItem.client = param.client;
      }
      taskItem.statusText = param.statusText;
      if (taskItem.status == panUtil.fileStatus.SUCCESS.code) {
        taskItem.percent = 100;
      } else {
        taskItem.percent = 0;
      }
    },
    updateProcess(state, param) {
      let taskItem = state.taskList.find(
        (taskItem) => param.fileName === taskItem.fileName
      );

      taskItem.abortCheckpoint = param.abortCheckpoint;

      // 控制一秒更新一次数据 防止刷新数据过快
      if (
        param.percentage != 100 &&
        taskItem.nowTime &&
        Math.floor(taskItem.nowTime / 1000) >= Math.floor(Date.now() / 1000)
      ) {
        return;
      }

      if (param.speed) {
        taskItem.speed = param.speed;
      } else {
        // 计算速度
        if (taskItem.nowTime && taskItem.uploadedSize) {
          taskItem.speed = parseInt(
            ((Number(param.uploadedSize) - Number(taskItem.uploadedSize)) /
              (Date.now() - taskItem.nowTime)) *
              1000
          );
        }
      }

      if (param.timeRemaining) {
        taskItem.timeRemaining = param.timeRemaining;
      } else {
        // 计算剩余时间
        if (taskItem.fileSize && taskItem.uploadedSize && taskItem.speed) {
          taskItem.timeRemaining = parseInt(
            Number(taskItem.fileSize - taskItem.uploadedSize) / taskItem.speed
          );
        }
      }

      taskItem.percentage = param.percentage;
      if (taskItem.uploadedSize > taskItem.fileSize) {
        taskItem.uploadedSize = taskItem.fileSize;
      } else {
        taskItem.uploadedSize = param.uploadedSize;
      }
      taskItem.nowTime = Date.now();
    },
    pause(state, fileName) {
      let taskItem = state.taskList.find(
        (taskItem) => fileName === taskItem.fileName
      );
      taskItem.client.cancel();
      taskItem.status = panUtil.fileStatus.PAUSE.code;
      taskItem.statusText = panUtil.fileStatus.PAUSE.text;
    },
    resume(state, fileName) {
      let taskItem = state.taskList.find(
        (taskItem) => fileName === taskItem.fileName
      );
      const file = taskItem.target;
      store.commit("task/updateStatus", {
        fileName: file.name,
        status: panUtil.fileStatus.WAITING.code,
        statusText: panUtil.fileStatus.WAITING.text,
      });
      taskItem.client.multipartUpload(taskItem.ossPath, file, {
        checkpoint: taskItem.abortCheckpoint,
        // 获取分片上传进度、断点和返回值。
        progress: (p, cpt, res2) => {
          // progressDiv.innerHTML = p;
          if (p == 1) {
            // 上传完成
            store.commit("task/updateStatus", {
              fileName: file.name,
              status: panUtil.fileStatus.MERGE.code,
              statusText: panUtil.fileStatus.MERGE.text,
            });
            store.commit("task/updateProcess", {
              fileName: file.name,
              // speed: panUtil.translateSpeed(file.averageSpeed),
              percentage: 100,
              uploadedSize: file.size,
              timeRemaining: 0,
            });

            fileService.createFolder(
              {
                fileName: file.name, //文件名
                fileType: "FILE", //文件类型 FILE,DIR
                resourceFlowNo: res.data.data.flowNo, //资源主键
                parentFlowNo: _this.parentId, //父级目录主键
              },
              () => {
                store.commit("task/updateStatus", {
                  fileName: file.name,
                  status: panUtil.fileStatus.SUCCESS.code,
                  statusText: panUtil.fileStatus.SUCCESS.text,
                });
                store.commit("task/updateProcess", {
                  fileName: file.name,
                  // speed: panUtil.translateSpeed(file.averageSpeed),
                  percentage: 100,
                  uploadedSize: file.size,
                  timeRemaining: 0,
                });
              },
              (err) => {
                store.commit("task/updateStatus", {
                  fileName: file.name,
                  status: panUtil.fileStatus.FAIL.code,
                  statusText: panUtil.fileStatus.FAIL.text,
                });
              }
            );
          } else {
            // 更新状态
            store.commit("task/updateProcess", {
              fileName: file.name,
              // speed: panUtil.translateSpeed(file.averageSpeed),
              percentage: Math.floor(p * 100),
              uploadedSize: Number(p * cpt.fileSize),
              abortCheckpoint: cpt,
            });
          }
        },
        // 设置并发上传的分片数量。
        parallel: 4,
        // 设置分片大小。默认值为1 MB，最小值为100 KB，最大值为5 GB。最后一个分片的大小允许小于100 KB。
        partSize: 1024 * 1024,
        // headers,
        // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
        meta: { year: 2020, people: "test" },
        mime: "text/plain",
        // 设置上传回调。
        // 如果不涉及回调服务器，请删除callback相关设置。
        // callback: {
        //   // 设置回调请求的服务器地址。
        //   url: "http://examplebucket.aliyuncs.com:23450",
        //   // 设置回调请求消息头中Host的值，即您的服务器配置Host的值。
        //   host: "yourHost",
        //   /* eslint no-template-curly-in-string: [0] */
        //   // 设置发起回调时请求body的值。
        //   body: "bucket=${bucket}&object=${object}&var1=${x:var1}",
        //   // 设置发起回调请求的Content-Type。
        //   contentType: "application/x-www-form-urlencoded",
        //   customValue: {
        //     // 设置发起回调请求的自定义参数。
        //     var1: "value1",
        //     var2: "value2",
        //   },
        // },
      });
      store.commit("task/updateStatus", {
        fileName: file.name,
        status: panUtil.fileStatus.UPLOADING.code,
        statusText: panUtil.fileStatus.UPLOADING.text,
      });
    },
    cancel(state, fileName) {
      let taskItem = state.taskList.find(
        (taskItem) => fileName === taskItem.fileName
      );
      taskItem.client.cancel();
      taskItem.status = panUtil.fileStatus.CANCEL.code;
      taskItem.statusText = panUtil.fileStatus.CANCEL.text;
    },
    retry(state, fileName) {
      function uuid() {
        var s = [];
        var hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";

        var uuid = s.join("");
        return uuid;
      }

      let taskItem = state.taskList.find(
        (taskItem) => fileName === taskItem.fileName
      );
      // return
      const _this = this;
      const file = taskItem.target;

      store.commit("task/updateStatus", {
        fileName: file.name,
        status: panUtil.fileStatus.WAITING.code,
        statusText: panUtil.fileStatus.WAITING.text,
      });

      store.commit("task/updateProcess", {
        fileName: file.name,
        speed: 0,
        percentage: 0,
        uploadedSize: 0,
        timeRemaining: 0,
      });

      let currentDate = new Date();
      const dirName =
        "resource/" +
        currentDate.getFullYear() +
        "/" +
        Number(currentDate.getMonth() + 1)
          .toString()
          .padStart(2, "0") +
        "/" +
        currentDate
          .getDate()
          .toString()
          .padStart(2, "0") +
        "/";
      const suffix = file.name.split(".")[
        file.name.split(".").length - 1
      ];
      const ossPath = dirName + uuid() + "." + suffix;

      MD5(file, (e, md5) => {
        fileService.secUpload(
          {
            md5Code: md5,
            ossPath: ossPath,
            orignName: file.name,
            resourceMemory: file.size,
          },
          (res) => {
            console.log("res", res);
            //
            if (!res.data.checked) {
              // 新文件
              const client = new OSS({
                // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                region: "oss-cn-beijing",
                authorizationV4: true,
                // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                accessKeyId: res.data.stsToken.accessKeyId,
                accessKeySecret: res.data.stsToken.accessKeySecret,
                // 从STS服务获取的安全令牌（SecurityToken）。
                stsToken: res.data.stsToken.securityToken,
                // 填写Bucket名称，例如examplebucket。
                bucket: "panresource",
              });
              client.multipartUpload(ossPath, file, {
                // 获取分片上传进度、断点和返回值。
                progress: (p, cpt, res2) => {
                  // progressDiv.innerHTML = p;
                  if (p == 1) {
                    // 上传完成
                    store.commit("task/updateStatus", {
                      fileName: file.name,
                      status: panUtil.fileStatus.MERGE.code,
                      statusText: panUtil.fileStatus.MERGE.text,
                    });
                    store.commit("task/updateProcess", {
                      fileName: file.name,
                      // speed: panUtil.translateSpeed(file.averageSpeed),
                      percentage: 100,
                      uploadedSize: file.size,
                      timeRemaining: 0,
                    });

                    fileService.createFolder(
                      {
                        fileName: file.name, //文件名
                        fileType: "FILE", //文件类型 FILE,DIR
                        resourceFlowNo: res.data.data.flowNo, //资源主键
                        parentFlowNo: _this.parentId, //父级目录主键
                      },
                      () => {
                        store.commit("task/updateStatus", {
                          fileName: file.name,
                          status: panUtil.fileStatus.SUCCESS.code,
                          statusText: panUtil.fileStatus.SUCCESS.text,
                        });
                        store.commit("task/updateProcess", {
                          fileName: file.name,
                          // speed: panUtil.translateSpeed(file.averageSpeed),
                          percentage: 100,
                          uploadedSize: file.size,
                          timeRemaining: 0,
                        });
                      },
                      (err) => {
                        store.commit("task/updateStatus", {
                          fileName: file.name,
                          status: panUtil.fileStatus.FAIL.code,
                          statusText: panUtil.fileStatus.FAIL.text,
                        });
                      }
                    );
                  } else {
                    // 更新状态
                    store.commit("task/updateProcess", {
                      fileName: file.name,
                      // speed: panUtil.translateSpeed(file.averageSpeed),
                      percentage: Math.floor(p * 100),
                      uploadedSize: Number(p * cpt.fileSize),
                      abortCheckpoint: cpt,
                    });
                  }
                },
                // 设置并发上传的分片数量。
                parallel: 4,
                // 设置分片大小。默认值为1 MB，最小值为100 KB，最大值为5 GB。最后一个分片的大小允许小于100 KB。
                partSize: 1024 * 1024,
                // headers,
                // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
                meta: { year: 2020, people: "test" },
                mime: "text/plain",
                // 设置上传回调。
                // 如果不涉及回调服务器，请删除callback相关设置。
                // callback: {
                //   // 设置回调请求的服务器地址。
                //   url: "http://examplebucket.aliyuncs.com:23450",
                //   // 设置回调请求消息头中Host的值，即您的服务器配置Host的值。
                //   host: "yourHost",
                //   /* eslint no-template-curly-in-string: [0] */
                //   // 设置发起回调时请求body的值。
                //   body: "bucket=${bucket}&object=${object}&var1=${x:var1}",
                //   // 设置发起回调请求的Content-Type。
                //   contentType: "application/x-www-form-urlencoded",
                //   customValue: {
                //     // 设置发起回调请求的自定义参数。
                //     var1: "value1",
                //     var2: "value2",
                //   },
                // },
              });
              store.commit("task/updateStatus", {
                fileName: file.name,
                status: panUtil.fileStatus.UPLOADING.code,
                statusText: panUtil.fileStatus.UPLOADING.text,
                client: client,
              });
            } else {
              // 已有文件，直接上传
              store.commit("task/updateStatus", {
                fileName: file.name,
                status: panUtil.fileStatus.MERGE.code,
                statusText: panUtil.fileStatus.MERGE.text,
              });
              fileService.createFolder(
                {
                  fileName: res.data.data.orignName, //文件名
                  fileType: "FILE", //文件类型 FILE,DIR
                  resourceFlowNo: res.data.data.flowNo, //资源主键
                  parentFlowNo: _this.parentId, //父级目录主键
                },
                () => {
                  store.commit("task/updateStatus", {
                    fileName: file.name,
                    status: panUtil.fileStatus.SUCCESS.code,
                    statusText: panUtil.fileStatus.SUCCESS.text,
                  });
                  store.commit("task/updateProcess", {
                    fileName: file.name,
                    // speed: panUtil.translateSpeed(file.averageSpeed),
                    percentage: 100,
                    uploadedSize: file.size,
                    timeRemaining: 0,
                  });
                },
                (err) => {
                  console.log("err", err);
                  store.commit("task/updateStatus", {
                    fileName: file.name,
                    status: panUtil.fileStatus.FAIL.code,
                    statusText: panUtil.fileStatus.FAIL.text,
                  });
                }
              );
            }
          },
          (err) => {
            console.log("err", err);
            store.commit("task/remove", file.name);
          }
        );
      });
    },
    updateViewFlag(state, viewFlag) {
      state.viewFlag = viewFlag;
    },
    changeViewFlag(state) {
      state.viewFlag = !state.viewFlag;
    },
  },
};

export default task;
